import l from "react";
import d from "classnames";
import { mintelGray300 as k, mintelGray500 as m, mintelWhite as u } from "mintel-tokens";
import { u as y } from "./ThemeProvider--i7ESlT5.es.js";
import { u as v } from "./DarkModeProvider-xoZXm3ct.es.js";
import { I as i } from "./Icon-BuIPTPJn.es.js";
import { T as g } from "./index-BB-Wk85r.es.js";
import { u as $ } from "./utils-C0l876fA.es.js";
import './Toggle.css';const N = "Toggle-default-module__button___Fwe8e", j = "Toggle-default-module__option___jVj1j", E = "Toggle-default-module__left___njmAT", F = "Toggle-default-module__selected___hROZO", C = "Toggle-default-module__text___rrvxG", V = "Toggle-default-module__right___5I-yd", I = "Toggle-default-module__dark___j-X49", U = "Toggle-default-module__disabled___RcCsa", z = "Toggle-default-module__icon___rfF8J", H = "Toggle-default-module__blue___lV073", J = "Toggle-default-module__gray___2HIm2", O = "Toggle-default-module__green___fHzl-", R = "Toggle-default-module__lavender___VUtt3", X = "Toggle-default-module__purple___yRAdu", Y = "Toggle-default-module__red___jCw4O", w = {
  button: N,
  option: j,
  left: E,
  selected: F,
  text: C,
  right: V,
  dark: I,
  disabled: U,
  icon: z,
  blue: H,
  gray: J,
  green: O,
  lavender: R,
  purple: X,
  red: Y
}, A = "Toggle-compere-module__button___kXOAx", G = "Toggle-compere-module__option___35btj", K = "Toggle-compere-module__left___t1VaJ", L = "Toggle-compere-module__selected___XKrdV", S = "Toggle-compere-module__text___g-Xud", M = "Toggle-compere-module__right___U8139", W = "Toggle-compere-module__dark___KYJKi", B = "Toggle-compere-module__disabled___8oYBk", D = "Toggle-compere-module__icon___LUbvz", Q = "Toggle-compere-module__blue___JUap-", Z = "Toggle-compere-module__gray___E0Yhr", h = "Toggle-compere-module__green___4e1Q-", q = "Toggle-compere-module__pink___jVwLT", P = "Toggle-compere-module__purple___5YUWM", ee = {
  button: A,
  option: G,
  left: K,
  selected: L,
  text: S,
  right: M,
  dark: W,
  disabled: B,
  icon: D,
  blue: Q,
  gray: Z,
  green: h,
  pink: q,
  purple: P
}, p = (n, e, t) => e && t ? "#FFFFFF80" : e ? k : t ? n ? m : u : n ? u : m, de = ({
  color: n = "gray",
  left: e,
  right: t,
  selectedValue: T,
  disabled: c = !1,
  onToggle: f
}) => {
  const { t: b } = $(), s = v(), o = y() === "compere" ? ee : w, _ = T === e.value;
  let a, r;
  _ ? (a = "title" in e ? e.title : e.text, r = "title" in t ? t.title : t.text) : (a = "title" in t ? t.title : t.text, r = "title" in e ? e.title : e.text);
  const x = b("{{selected}} selected. Click to select {{unselected}}", {
    selected: a,
    unselected: r
  });
  return /* @__PURE__ */ l.createElement(
    "button",
    {
      type: "button",
      className: d(o.button, {
        [o.disabled]: c,
        [o.dark]: s
      }),
      onClick: () => {
        f(_ ? t.value : e.value);
      },
      "aria-label": x,
      disabled: c
    },
    /* @__PURE__ */ l.createElement(
      "div",
      {
        className: d(o.option, o.left, o[n], {
          [o.selected]: _
        }),
        "data-testid": "toggle-left",
        title: "title" in e ? e.title : void 0
      },
      "icon" in e && e.icon && /* @__PURE__ */ l.createElement(
        i,
        {
          color: p(_, c, s),
          className: o.icon,
          name: e.icon,
          size: "1.25rem"
        }
      ),
      "text" in e && e.text && /* @__PURE__ */ l.createElement(g.Heading6, { className: o.text, responsive: !0, tagName: "span" }, e.text)
    ),
    /* @__PURE__ */ l.createElement(
      "div",
      {
        className: d(o.option, o.right, o[n], {
          [o.selected]: !_
        }),
        "data-testid": "toggle-right",
        title: "title" in t ? t.title : void 0
      },
      "icon" in t && t.icon && /* @__PURE__ */ l.createElement(
        i,
        {
          color: p(!_, c, s),
          className: o.icon,
          name: t.icon,
          size: "1.25rem"
        }
      ),
      "text" in t && t.text && /* @__PURE__ */ l.createElement(g.Heading6, { className: o.text, responsive: !0, tagName: "span" }, t.text)
    )
  );
};
export {
  de as T
};
